import React from 'react';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';

export const ServiceLevelColumns = (handleEdit, handleDelete) => {
    return [
        {
            field: 'service_level',
            headerName: 'ServiceLevel',
            width: 200,
            sortable: true
        },
        {
            field: 'edit',
            headerName: 'Actions',
            width: 140,
            renderCell: (params) => (
                <>
                    <IconButton aria-label="edit" onClick={() => handleEdit(params.row)}>
                        <ModeEditIcon className='ml-5 edit-color' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleDelete(params.row)}>
                        <DeleteIcon className='ml-5 delete-color' />
                    </IconButton>
                </>
            )
        }
    ];
};
